/**
 * Frontend API configuration — single source of truth for all backend URLs.
 *
 * Set at build/start time (Create React App embeds REACT_APP_* at compile time):
 *
 *   REACT_APP_BACKEND_ORIGIN=https://workloop.chat
 *   REACT_APP_API_URL=https://workloop.chat/api
 *   REACT_APP_WS_URL=https://workloop.chat/ws
 *   REACT_APP_CUMIN_API_URL=https://your-cumin-host
 *
 * npm (production backend):
 *   npm run build:workloop
 *   REACT_APP_BACKEND_ORIGIN=https://custom.example.com npm run build:api
 *
 * Jenkins:
 *   REACT_APP_BACKEND_ORIGIN=https://workloop.chat npm run build:api
 *   BACKEND_ORIGIN=https://workloop.chat npm run build:api
 */

const PRODUCTION_BACKEND_ORIGIN = 'https://workloop.chat';
const LOCAL_BACKEND_ORIGIN = 'http://192.168.1.50:3601';
const DEFAULT_CUMIN_API_URL = 'http://103.145.50.107:3500';

const trimTrailingSlash = (value) => (value || '').replace(/\/+$/, '');

const trimEnv = (value) => (value || '').trim();

/** Trim whitespace, remove spaces inside URLs, and strip trailing slashes */
const normalizeUrl = (value) =>
  trimTrailingSlash(trimEnv(value).replace(/\s+/g, ''));

const resolveBackendOrigin = () => {
  const backendOriginEnv = trimEnv(process.env.REACT_APP_BACKEND_ORIGIN);
  if (backendOriginEnv) {
    return normalizeUrl(backendOriginEnv);
  }

  const apiUrlEnv = trimEnv(process.env.REACT_APP_API_URL);
  if (apiUrlEnv) {
    return normalizeUrl(apiUrlEnv.replace(/\/api\/?$/, ''));
  }

  if (process.env.NODE_ENV === 'development') {
    return LOCAL_BACKEND_ORIGIN;
  }

  return PRODUCTION_BACKEND_ORIGIN;
};

/** Backend host only, e.g. https://workloop.chat */
export const BACKEND_ORIGIN = resolveBackendOrigin();

/** REST API base, e.g. https://workloop.chat/api */
export const API_URL =
  normalizeUrl(trimEnv(process.env.REACT_APP_API_URL) || `${BACKEND_ORIGIN}/api`);

/** WebSocket endpoint, e.g. https://workloop.chat/ws */
export const WS_URL =
  normalizeUrl(trimEnv(process.env.REACT_APP_WS_URL) || `${BACKEND_ORIGIN}/ws`);

/** External CUMIN service URL (issue tracker UI/API host) */
export const CUMIN_API_URL =
  normalizeUrl(trimEnv(process.env.REACT_APP_CUMIN_API_URL) || DEFAULT_CUMIN_API_URL);

/** @deprecated Use BACKEND_ORIGIN */
export const BASE_HOST = BACKEND_ORIGIN;
